"use client";
import { useEffect, useRef, useState } from "react";
import {
  type Cart as CartData,
  CartType,
} from "@cappelendamm/e-commerce-services";
import { useCart } from "@/cart";
import { Button, Card } from "@cappelendamm/design-system/react";
import { Xmark } from "iconoir-react";
import { getCartNumberOfItems } from "../selectors";
import { UNINITIALIZED_CART } from "@/cart/initial-cart";
import { usePathname } from "next/navigation";

export function CartToast() {
  const { cart, openCart, cartOpen } = useCart();
  const [message, setMessage] = useState<string | null>(null);
  const referenceCartData = useRef<CartData | null>(cart);
  const pathname = usePathname();

  const isCardPaymentPage = pathname.startsWith("/utsjekk/betaling");
  const shouldShowToast =
    cart?.cartType !== CartType.EVALUATION_COPY && !isCardPaymentPage;

  useEffect(() => {
    const numberOfItemsInCart = getCartNumberOfItems(cart);

    if (
      !cartOpen &&
      Boolean(referenceCartData.current) &&
      numberOfItemsInCart > 0 &&
      numberOfItemsInCart !== getCartNumberOfItems(referenceCartData.current) &&
      referenceCartData.current?.id !== UNINITIALIZED_CART.id
    ) {
      setMessage(
        `Totalt ${numberOfItemsInCart} vare${numberOfItemsInCart > 1 ? "r" : ""}`,
      );
    }
    referenceCartData.current = cart;
  }, [cart, cartOpen]);

  useEffect(() => {
    const timerBasedOnExitOption = 10000;
    const timeoutId = setTimeout(() => {
      setMessage(null);
    }, timerBasedOnExitOption);
    return () => {
      clearTimeout(timeoutId);
    };
  }, [message, setMessage]);

  if (!message || !shouldShowToast) return null;

  return (
    <Card
      role="alert"
      className="fixed bottom-0 left-0 z-50 grid h-min w-full auto-rows-min grid-cols-[1fr_auto] gap-4 rounded-xl p-4 sm:absolute sm:top-8 sm:right-8 sm:bottom-auto sm:left-auto sm:w-fit"
    >
      <span>Varen er lagt i handlekurv</span>
      <button className="focus:cvr-focus" onClick={() => setMessage(null)}>
        <Xmark className="inline" width={24} height={24} />
      </button>
      <span className="col-span-full">{message}</span>
      <Button
        className="col-span-full h-fit"
        onClick={() => {
          openCart();
          setMessage(null);
        }}
      >
        Se handlekurv
      </Button>
    </Card>
  );
}
